import TopBar from "@/pages/home/components/TopBar";
import UpdateTicker from "@/pages/home/components/UpdateTicker";
import Hero from "@/pages/home/components/Hero";
import EntryGrid from "@/pages/home/components/EntryGrid";
import LineStatus from "@/pages/home/components/LineStatus";
import VersionCollections from "@/pages/home/components/VersionCollections";
import UpdateFeed from "@/pages/home/components/UpdateFeed";
import GuideSteps from "@/pages/home/components/GuideSteps";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <TopBar />
      <UpdateTicker />
      <main>
        <Hero />
        <EntryGrid />
        <LineStatus />
        <VersionCollections />
        <UpdateFeed />
        <GuideSteps />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}